export default __webpack_public_path__ + "static/media/background-visits.397f0579.svg";